import { useMenu as x } from "../../hooks/useMenu.js";
import { useCallback as S } from "react";
import { usePopover as B } from "../../../Popover/hooks/usePopover.js";
import { usePopoverItem as E } from "../../../Popover/hooks/usePopoverItem.js";
const j = ({
  canToggle: t,
  onClick: s,
  onKeyDown: d,
  role: c,
  selected: g,
  value: f
}) => {
  const l = x(), b = B(), a = l != null && l.supportsSelection ? l.isSelected(f) : g, h = S(
    (r) => {
      s == null || s(r), M(l, f, a, b, t);
    },
    [t, l, s, b, a, f]
  ), I = S(
    (r) => {
      d == null || d(r), r.key === "Tab" && (l != null && l.supportsSelection) && (l != null && l.changeOnBlur) && (l == null || l.toggle(f, !0));
    },
    [l, d, f]
  ), { tabIndex: P, ...k } = E(
    void 0,
    O(
      {
        canToggle: t,
        onClick: s,
        onKeyDown: d,
        value: f
      },
      l,
      a
    )
  );
  return {
    ...k,
    onClick: h,
    onKeyDown: I,
    tabIndex: c === "option" ? P : void 0
  };
}, M = (t, s, d, c, g) => {
  var f, l, b;
  t != null && t.supportsSelection && t.toggle(s, g || t != null && t.multiSelect ? !d : !0), t != null && t.hasArrowKeyNav && !(t != null && t.multiSelect) && ((f = c == null ? void 0 : c.setShow) == null || f.call(c, !1), (b = (l = c == null ? void 0 : c.getFocusableActivator) == null ? void 0 : l.call(c)) == null || b.focus());
}, O = (t, s, d) => ({
  onBlur: () => (s == null ? void 0 : s.changeOnBlur) && (s == null ? void 0 : s.toggle(t.value, !0)),
  onKeyDown: (c) => {
    var g, f;
    if (c.key === "Enter") {
      c.preventDefault(), s == null || s.toggle(
        t.value,
        t.canToggle || s != null && s.multiSelect ? !d : !0
      );
      const l = new Event("click", {
        bubbles: !0
      });
      Object.defineProperty(l, "target", {
        writable: !1,
        value: { value: "", ...c.target }
      }), (g = t.onClick) == null || g.call(t, l);
    }
    (f = t.onKeyDown) == null || f.call(t, c);
  }
});
export {
  j as useMenuItemInteractions
};
